
import React, { Component } from "react";
import {Icon, Rate, Button, Row, Col} from 'antd'
import {  Link } from "react-router-dom"
import {  Button as SVAButton } from 'antd';
import Badge from 'react-bootstrap/Badge'
import SojStars from '../terrain/SojStars'

import {SJPROBATESHOW} from '../../constants'


const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );

   const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

  

class SojTerrainLocationSVPriceListView extends Component {
    
    drawStars(o){
        let svrstars = {
            "sv_rating_no":o.sojStar ? o.sojStar : 2  ,
            "color": "#e8a01899"
        }
        return(<SojStars svrstars={svrstars} ></SojStars>)

    }
    //sjjul2
    reloadHotelPageSV=(ob )=>(e)=>{
        let me = this
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SJJul2 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }
        let abodespaceid  = me.props.priceInfo.o.abodespaceid
        console.log('sjjul2', abodespaceid)
        return (
            <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetsojourn/svredsojourn/${abodespaceid}`}> Hotel Detail   </Link></Button>
        )

       
        

    }
    reloadSJReviewPageSV=(ob )=>(e)=>{
        let me = this
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SVOCT25 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }

        /*
         me.props.sjofferselectparent(cidOffer, ob.flight_space_key) 
       
        */
        me.props.sjofferselectparent(cidOffer, ob.price_key) 
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    //sjjul14y25
    reloadSJHotelPageSV=(ob )=>(e)=>{
        let me = this
        console.log('sv****Got the page reloadSJHotelPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SVOCT25 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }

        /*
         me.props.sjofferselectparent(cidOffer, ob.flight_space_key) 
       
        */
        me.props.sjhotelselectparent(cidOffer, ob.price_key) 
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    reloadSJPbcourtPageSV=(ob )=>(e)=>{
        let me = this
        console.log('sv****Got the page reloadSJPbcourtPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SVOCT25 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }

        /*
         me.props.sjofferselectparent(cidOffer, ob.flight_space_key) 
       
        */
        me.props.sjprobatecourtselectparent(cidOffer, ob.price_key) 
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    reloadMySojReservationReviewPageSV=(masterCustOffer )=>(e)=>{
        let me = this
        let ob = masterCustOffer.o
        let svcustProfile = masterCustOffer.svcustProfile
        console.log('sv****Got the nov19  page reloadMySojReservationReviewPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SV nov19 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }
        me.props.sjofferselectparent(cidOffer, ob.flight_space_key, svcustProfile) 
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    getFSKReserveHtmlButton(o,svcustProfile){
        let me = this
        let customerId = -1
       
        /*
         console.log('sv******** getFSKReserveHtmlButton start ')
        console.log(o)
        console.log(svcustProfile)
        console.log('sv******** getFSKReserveHtmlButton end')
onClick={me.reloadSJReviewPageSV(o).bind(this)}
        */
        if(!svcustProfile){
            return( <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>
            )
           
        }
        if(typeof(svcustProfile.customerId) == "string"){
            customerId = parseInt(svcustProfile.customerId )
        }else{
            customerId = svcustProfile.customerId
        }
       console.log("customerId:", customerId)
        if(customerId > 0){
            let masterCustOffer = {
                "svcustProfile": svcustProfile,
                "o":o
            }
            return( <SVAButton onClick={me.reloadMySojReservationReviewPageSV(masterCustOffer).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >MyFlightReserve </SVAButton>
            )
            /*
            return (<Button  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myflyreservationsSV/${customerId}/flyressvCustNew/${o.flight_space_key}`}> MyFlightReserve  </Link></Button>)
            */

        }else{
            //working July2y25 it will be hotelid extracted from ratekey
            if(SJPROBATESHOW){

                return( <div> <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>
                <SVAButton onClick={me.reloadSJHotelPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >Hotel Detail </SVAButton>
                
                </div>)

            }

            return( <div> <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>
            <SVAButton onClick={me.reloadSJHotelPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJHotel IDetail </SVAButton>
            
             </div>)
           
            /*

             return( <div> <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>
            <SVAButton onClick={me.reloadSJHotelPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJHotel IDetail </SVAButton>
           <SVAButton onClick={me.reloadSJPbcourtPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >NJW </SVAButton>
            
             </div>)
           
             return( <div> <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>
            <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetsojourn/svredsojourn/${o.abodespaceid}`}> Hotel Detail   </Link></Button>
           
             </div>)
           

             {
                this.reloadHotelPageSV(o).bind(this)
            }
            
            return( <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>)
            */
            /*
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >IReserve</Button>)
            */
        }
        
    }

    getASKReserveHtmlButton(o,svcustProfile){
        let customerId = -1
        if(!svcustProfile){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetsojourn/shredbook/${o.space_key}`}> SJReserve  </Link></Button>)
             
        }
        if(typeof(svcustProfile.customerId) == "string"){
            customerId = parseInt(svcustProfile.customerId )
        }else{
            customerId = svcustProfile.customerId
        }
       console.log("customerId:", customerId)
       if(customerId > 0){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${customerId}/reservesvCustNew/${o.space_key}`}> MyReserve  </Link></Button>)
        

        }else{

            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetsojourn/shredbook/${o.space_key}`}> IReserve  </Link></Button>)
            
        }
        
    }
    constructor(props) {
        super(props)
        let me = this
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }
        this.drawStars = this.drawStars.bind(me)
        this.reloadSJReviewPageSV = this.reloadSJReviewPageSV.bind(me)
        //reloadSJHotelPageSV 
        this.reloadSJHotelPageSV = this.reloadSJHotelPageSV.bind(me)
        this.reloadHotelPageSV = this.reloadHotelPageSV.bind(me)
       
        this.reloadMySojReservationReviewPageSV = this.reloadMySojReservationReviewPageSV.bind(me)
         
         this.getASKReserveHtmlButton = this.getASKReserveHtmlButton.bind(this)
        this.getReserveHtmlButton = this.getReserveHtmlButton.bind(this)
        this.getHotelAmenityList = this.getHotelAmenityList.bind(this)
        this.getFSKReserveHtmlButton = this.getFSKReserveHtmlButton.bind(this)
       
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(this)

        /*pbaug1 */
        this.reloadSJPbcourtPageSV = this.reloadSJPbcourtPageSV.bind(me)
        

    }
    getHotelAmenityList(ar){
        
        
        ar = ar || []
       return ar.map( (v, idx)=>{
           if(v.toLocaleLowerCase() == "swimming beach"){
               return(
                                                                             
                 <span className="o-box-amnlist-b1" style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}sv</text></span>                                
               )
            
           }else if(v.toLocaleLowerCase() == "tennis"){ 
                return(
                                                                             
                  <span className="o-box-amnlist-b1" style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>                        
              ) 
            

           }else if(v.toLocaleLowerCase() == "water"){  
                 return(
                                                                            
                     <span className="o-box-amnlist-b1" style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>                    
                    ) 
           }else{

                return(
                                                                                
                        <span className="o-box-amnlist-b1" style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>                  
                   ) 
            
           }
          })
       


    }
    /*
<div className="o-container-amnlist">
                                                      
                                                      <div className="o-box-amnlist-b1">
                                                                                      
                                                          
                                                      </div>
                                            </div>

    */
    getHotelAmenityList_span(ar){
        
        
        ar = ar || []
       return ar.map( (v, idx)=>{
           if(v.toLocaleLowerCase() == "swimming beach"){
            return (<span style={{fontSize: "14px"}} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }else if(v.toLocaleLowerCase() == "tennis"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else if(v.toLocaleLowerCase() == "water"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else{

            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }
          })
       


    }
    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
        console.log(param1)
		let me = ctx
		me.currentSelection = param1.sojourncode
		console.log('sv delete task curry')
		console.log(param1.sojourncode)
		//me.props.svWrappedDeleteTaskActionCreator(param1.id)
	}
   
    getReserveHtmlButton(o,customerId){
        if(customerId > 0){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${customerId}/reservesvCustNew/${o.space_key}`}> MyReserve  </Link></Button>)
            

        }else{

            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetabode/svredbook/${o.space_key}`}> Reserve  </Link></Button>)
            
        }
        
    }
    render() {
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.svrlocation)
        let customerId = -1
        const {svcustProfile, priceInfo} = this.props
        const {o} = priceInfo
        let soj_coler = "rgb(189, 33, 33)"
        let soj_icon = "slack-square"
        if(o['hotel_soldout'] && (o['hotel_soldout'] === 'Y') ){
            console.log('SJ**HOTEL SOLDOUT')
            console.log(o['hotel_soldout'])
            soj_coler =  "rgb(189, 33, 33)"
            soj_icon =  "close-square"
            o.roomsAvailable = 0
        }else{
            console.log('SJ**HOTEL HAS hotel_soldout AVAAILABILIT OR DATA ISSUE')
        }
//svjun9
       // console.log(o['HOTEL_SOLDOUT'])
        
        let webrl = "https://www.w3schools.com"
        console.log('############### price ****************')
        console.log(o)
        /*
        if(svcustProfile && svcustProfile.customerId > 0){
            if(typeof(svcustProfile.customerId) == "string"){
                customerId = parseInt(svcustProfile.customerId )
                }else{
                    customerId = svcustProfile.customerId
                }
                console.log('sv customerId:', customerId)
           console.log('myreservationSpace')
       }else{
            console.log('internet userSpace')
        }
        */
        if(svcustProfile && svcustProfile.customerId ){
            if(typeof(svcustProfile.customerId) == "string"){
                customerId = parseInt(svcustProfile.customerId )
            }else{
                customerId = svcustProfile.customerId
            }
            if(customerId > 0){
           console.log('myreservationSpace')
           }else{
            console.log('internet userSpace')
           }
        }

        return (
            <div className="svr-sojlist-boxl-2">
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                     
                <p className="m-para-text-first" style={{paddingTop:"0", marginTop:"0"}}>
                    <span> 
                        <text className="svr-hotel-name"  style={{maxWidth:"320px",fontSize:"1.5.em", paddingRight:"10px",color:"rgb(208, 156, 31)"}}>{this.props.svrlocation.resort_name}</text>
        
                        <Icon  style={{ color:"rgb(215, 125, 10)" , fontSize:"20px" }} type={soj_icon} theme="filled" />
                    </span>
                    {/*
                     <span className="ter-l2 svr-hotel-location" style={{marginTop:"0px", marginBottom:"0px"}}>
                        <text style={{fontSize:"15px", color:"rgb(132, 115, 97)", fontWeight:"400", paddingRight:"15px"}}>
                        {this.props.svrlocation.address_line1}, {this.props.svrlocation.city}, {this.props.svrlocation.postalcode} , {this.props.svrlocation.country} 
                        </text>
                        <Icon  style={{ color: "rgb(7, 115, 29)", fontSize:"20px" }} type="environment" theme="filled" />
                        <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>{this.props.svrlocation['space_key']}-Map</text> 
                    </span>  */}
                    <span className="ter-l2 svr-hotel-location" style={{marginTop:"0px", marginBottom:"0px"}}>
                        <text style={{fontSize:"10px", color:"rgb(132, 115, 97)", fontWeight:"400", paddingRight:"15px"}}>
                        {this.props.svrlocation.address_line1}, {this.props.svrlocation.city}, {this.props.svrlocation.postalcode} , {this.props.svrlocation.country} 
                        </text>
                        <Icon  style={{ color: "rgb(7, 115, 29)", fontSize:"20px" }} type="environment" theme="filled" />
                        <text style={{fontSize:"12px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>Map</text> 
                    </span>
                        
                    <span style={{fontSize: "12px"}} style={{marginTop:"0px",display:"block", marginBottom:"0px"}} > 
                       
                        <text style={{fontSize:"10px", color:"rgb(129, 133, 142)",paddingRight:"10px", paddingLeft:"0px",fontWeight:"400"}}> {this.props.svrlocation.num_reviews} reviews</text>
                        <Icon  style={{ fontSize:"14px",color: '#eb2f96' }} type="car" theme="filled" />
                        <text style={{fontSize:"10px", color:"rgb(129, 133, 142)", paddingLeft:"10px",paddingRight:"10px",fontWeight:"420"}}>{this.props.svrlocation.nearest_airport_distance_mi_lvl}  miles from {this.props.svrlocation.en_nearest_airports_lvl} Airport</text>
                      {/* <Link to={`${webrl}`} > Contact us </Link>  */}  
                        <Icon  style={{fontSize:"14px", color: '#eb2f96' }} type="dingtalk-square" theme="filled" />
                        <a href={`${o.web}`}><text style={{fontSize:"12px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>Website</text></a> 
                       
                    </span>
                    <span style={{fontSize: "12px"}} style={{marginTop:"0px",display:"block", marginBottom:"0px"}}  >
                        { this.drawStars(o)}
                    </span>
                    
                </p>
                </div>
                                        <div className="box-right-listhotels">
                                        
                                        
                                        <p className="m-para-text-first">
                                                <text style={{display:"block"}} className="svr-hotel-rating">{o.sv_rating?  o.sv_rating: "Excellent"}  </text>
                                                <text style={{color:'#0d66b5',display:"block"}} className="f12 d-block"><Badge style={{backgroundColor:'#0aa40a', padding:'5px'}} variant="secondary">R: {o.ranking ? o.ranking : 5 }</Badge>   </text>
                                         </p>
                                        
                                          
                                        </div>``
                                    </div>

                                    <div className="box-outer-listhotels" style={{fontSize:"1.0em"}}>
                                        <div className="box-left-listhotels">
                                           
                                            <p className="m-para-text">
                                            <div>
                                               
                                               <text style={{color:'#b091b0'}} className="f12  d-block"> sj{o.roomMeta?  o.roomMeta: "2 SVQueen Beds"}  </text>
                                               <span onClick={  this.deleteTaskCurryParams(o, this)}  style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="trophy" theme="filled" /><text style={{paddingLeft: "10px", color: soj_coler}}>{o.roomsAvailable} Rooms Left</text></span>
                                            </div>
                                            {/*   
                                             <div className="o-container-amnlist">
                                                {this.getHotelAmenityList(o.en_activity_name_lvl)}
                                                <span  className="o-box-amnlist-b1" style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Wifi</text></span>
                                                <span className="o-box-amnlist-b1"  style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Bath tub</text></span>
                                                
                                            </div>
                                            */}
                                           
                                            
                                               
                                                
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <div>
                                                <text className="svr-hotel-stay">2night, 2days </text>
                                                <text className="svr-hotel-price d-block"> {o.product_cost_amount ?o.product_cost_amount: '$117' }</text>
                                                </div>
                                            </p>
                                         

                                              {this.getFSKReserveHtmlButton(o,svcustProfile)}
                                            
                                            {/*
                                            this.getASKReserveHtmlButton(o,svcustProfile)
                                               
                                            
                                              
                                            
                                            
                                            */}

                                            {/* 
                                            
                                            this.getReserveHtmlButton(o,customerId)
                                               <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetsojourn/shredbook/${o.space_key}`}> Reserve  </Link></Button>
        
                                            */}

                                           
                                        </div>
                                    </div>
                                   
                                </div>
          
        )
    }

}

export default SojTerrainLocationSVPriceListView;